import { getResource } from "../language/resources/getResource"


export const rtpColumnConfig = (resources: Record<string, any>, hasFulfillmentSeason: boolean, showHydrationErrors: boolean) => {
  return [
    { title: getResource(resources, 'RESORT_MAPPING_COLUMN_PRODUCT'), property: 'product' },
    { title: getResource(resources, 'RESORT_MAPPING_COLUMN_SEASON'), property: 'season' },
    { title: getResource(resources, 'RESORT_MAPPING_COLUMN_AGE'), property: 'ageBin' },
    ...hasFulfillmentSeason 
      ?  [{ title: getResource(resources, 'RESORT_MAPPING_COLUMN_FULFILLMENT_SEASON'), property: 'fulfillmentSeason' }]
      : [],
    { title: getResource(resources, 'RESORT_MAPPING_COLUMN_PRODUCT_HEADER_CODE'), property: 'productHeaderCode' },
    { title: getResource(resources, 'RESORT_MAPPING_COLUMN_ACCESS_RULE'), property: 'accessRule' },
    { title: getResource(resources, 'RESORT_MAPPING_COLUMN_MEDIA_PRODUCT_HEADER_CODE'), property: 'mediaProductHeaderCode' },
    { title: getResource(resources, 'RESORT_MAPPING_COLUMN_MAPPING_STATUS'), property: 'errorDescription'},
    ...showHydrationErrors
      ? [{ title: getResource(resources, 'RESORT_MAPPING_COLUMN_HYDRATION_ERRORS'), property: 'hydrationErrors'}]
      : []
    ]
}

export const swColumnConfig = (resources: Record<string, any>, hasFulfillmentSeason: boolean, showHydrationErrors: boolean) => {
  return [
    { title: getResource(resources, 'RESORT_MAPPING_COLUMN_PRODUCT'), property: 'product' },
    { title: getResource(resources, 'RESORT_MAPPING_COLUMN_SEASON'),  property: 'season' },
    { title: getResource(resources, 'RESORT_MAPPING_COLUMN_AGE'), property: 'ageBin' },
    ...hasFulfillmentSeason 
    ?  [{ title: getResource(resources, 'RESORT_MAPPING_COLUMN_FULFILLMENT_SEASON'), property: 'fulfillmentSeason' }]
    : [],
    { title: getResource(resources, 'RESORT_MAPPING_COLUMN_DEPARTMENT'), property: 'department' },
    { title: getResource(resources, 'RESORT_MAPPING_COLUMN_CATEGORY'), property: 'category' },
    { title: getResource(resources, 'RESORT_MAPPING_COLUMN_ITEM'), property: 'item' },
    //{ title: getResource(resources, 'RESORT_MAPPING_COLUMN_PRODUCT_TYPE'), property: 'productType' },
    //{ title: getResource(resources, 'RESORT_MAPPING_COLUMN_WTP_RELOAD'), property: 'wtpReload' },
    { title: getResource(resources, 'RESORT_MAPPING_COLUMN_MAPPING_STATUS'), property: 'errorDescription'},
    ...showHydrationErrors
      ? [{ title: getResource(resources, 'RESORT_MAPPING_COLUMN_HYDRATION_ERRORS'), property: 'hydrationErrors'}]
      : []
   ]
}
